import { mapState } from 'vuex';

import Row from '@/components/content-management/row-container';
import Column from '@/components/content-management/column-container';
import Section from '@/components/content-management/section-container';
import SectionStudent from '@/components/content-management/section-container-student';
import Banner from '@/components/content-management/banner';

export default {
  name     : 'Generic',
  props    : ['model', 'academicMainId', 'academicMainTypeId'],
  computed : {
    ...mapState({
      isStudentView: state => state.plataforma.content.isStudentView
    }),
    comp() {
      if (typeof this.model === 'object') {
        return {
          row     : Row,
          section : this.isStudentView ? SectionStudent : Section,
          banner  : Banner
        }[this.model.type] || Column;
      }
    },
    props() {
      if (typeof this.model === 'object') {
        if (this.model.type === 'banner') {
          return {
            title              : this.model.title,
            image              : this.model.image,
            id                 : this.model.key,
            academicMainId     : this.academicMainId,
            academicMainTypeId : this.academicMainTypeId,
            isStudent          : this.isStudentView
          };
        }

        return {
          drag               : this.model.drag,
          items              : this.model.items,
          academicMainId     : this.academicMainId,
          academicMainTypeId : this.academicMainTypeId,
          styles             : this.model.styles
            ? {
              paddingLeft  : this.model.styles.paddingLeft,
              paddingRight : this.model.styles.paddingRight
            }
            : {}
        };
      } else {
        return {
          data               : this.model,
          academicMainId     : this.academicMainId,
          academicMainTypeId : this.academicMainTypeId
        };
      }
    }
  },
  methods: {
    addElement() {
      this.$nuxt.$emit('management-events', {
        type : 'addElement',
        data : this.model
      });
    },
    removeElement() {
      this.$nuxt.$emit('management-events', {
        type : 'removeElement',
        data : this.model
      });
    },
    saveElement(value) {
      this.$nuxt.$emit('management-events', {
        type : 'saveElement',
        data : {
          ...this.model,
          items: {
            ...this.model.items,
            content: value
          }
        }
      });
    }
  }
};
